export default __webpack_public_path__ + "static/media/instagram.inline.fee27ece.svg";